import React from 'react';
import { RefineThemes } from '@refinedev/antd';
import { ConfigProvider, theme } from 'antd';
import { createContext, useEffect, type PropsWithChildren } from 'react';

type ColorModeContextType = {
  mode: string;
  setMode: (mode: string) => void;
};

export const ColorModeContext = createContext<ColorModeContextType>(
  {} as ColorModeContextType
);

export const ColorModeContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  let mode = 'light';

  useEffect(() => {
    window.localStorage.setItem('colorMode', mode);
  }, [mode]);

  const setColorMode = () => {
    mode = 'light';
  };

  const { darkAlgorithm, defaultAlgorithm } = theme;

  return (
    <ColorModeContext.Provider
      value={{
        setMode: setColorMode,
        mode,
      }}
    >
      <ConfigProvider
        // you can change the theme colors here. example: ...RefineThemes.Magenta,
        theme={{
          ...(RefineThemes.Blue as Record<string, unknown>),
          algorithm: mode === 'light' ? defaultAlgorithm : darkAlgorithm,
          token: {
            fontFamily: 'Poppins',
            fontFamilyCode: 'Poppins',
            colorPrimary: '#C01E2E',
          },
        }}
      >
        {children}
      </ConfigProvider>
    </ColorModeContext.Provider>
  );
};
